import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName="reminder";

export function insert(parameter){
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}

export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function businessIdExists(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/businessIdExists`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectByBusinessId(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectByBusinessId`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryReminderList(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryReminderList`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryReminderListByBusinessId(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryReminderListByBusinessId`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function deleteByIds(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function deleteRemind(ids){
  console.log("ids",ids)
  return axios({
    url: `/ws/${moduleName}/deleteRemind`,
    method: 'delete',
    params:ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function deleteByUserIds(userId){
  console.log("ids",userId)
  return axios({
    url: `/ws/${moduleName}/deleteByUserId/${userId}`,
    method: 'delete',
  })
}

export default {
  selectAll,
  deleteByIds,
  deleteByUserIds,
  insert,
  deleteRemind,
  update,
  queryReminderList,
  selectByBusinessId,
  businessIdExists,
  queryReminderListByBusinessId
}